var _class;
import { Record, List } from 'immutable';
import { IMAGE_TYPES } from '../../constants/categoryManagement/HomepageCategorySettings';
import { NameTranslationRecord } from '../CategoryTranslationRecord';
import { convertTranslationsToOldFormat } from '../../migration-handler/singleton/migrationHandler';
export const homepageCategoryEmptyState = {
  parentCategoryId: 0,
  position: 0,
  name: '',
  description: undefined,
  fullPath: '',
  translatedFromId: undefined,
  imageSrc: undefined,
  iconName: undefined,
  iconType: undefined,
  iconUnicode: undefined,
  articleIds: List(),
  isDisplayed: false,
  color: undefined,
  imageTypeEnum: IMAGE_TYPES.ICON,
  imageType: 0,
  knowledgeBaseId: 0,
  createdAt: 0,
  createdById: 0,
  updatedAt: 0,
  updatedById: 0,
  deletedAt: 0,
  id: 0,
  language: '',
  portalId: 0,
  translations: {},
  nameTranslations: List()
};
export default class CategoryDetailsRecord extends Record(homepageCategoryEmptyState) {}
_class = CategoryDetailsRecord;
CategoryDetailsRecord.fromJS = json => {
  const nameTranslations = convertTranslationsToOldFormat(json);
  return new _class(Object.assign({}, json, {
    articleIds: List(json.articleIds || []),
    nameTranslations: List(nameTranslations.map(NameTranslationRecord))
  }));
};
CategoryDetailsRecord.toRequest = record => {
  return Object.assign({}, record.toJS(), {
    articleIds: record.articleIds.toJS()
  });
};
export const HomepageCategoryStateRecord = Record({
  error: undefined,
  isLoading: false,
  category: new CategoryDetailsRecord(),
  primaryLanguage: undefined,
  lastLoaded: undefined,
  isRequesting: false
});